/**
 * Zichtbaarheid en sessie-dismiss voor de e-mailverificatiebanner.
 */
import { isPasswordAuthUser } from '@/services/authEmailVerification';

export const EMAIL_VERIFICATION_DISMISS_SESSION_KEY =
  'auth.emailVerificationBanner.dismissed';

/**
 * @param {import('firebase/auth').User | null | undefined} user
 * @param {boolean} dismissed
 */
export const shouldShowEmailVerificationBanner = (user, dismissed) => {
  if (!user || dismissed) {
    return false;
  }
  if (!isPasswordAuthUser(user)) {
    return false;
  }
  return user.emailVerified === false;
};

export const readBannerDismissed = () => {
  try {
    return sessionStorage.getItem(EMAIL_VERIFICATION_DISMISS_SESSION_KEY) === '1';
  } catch {
    return false;
  }
};

export const persistBannerDismissed = () => {
  try {
    sessionStorage.setItem(EMAIL_VERIFICATION_DISMISS_SESSION_KEY, '1');
  } catch {
    // storage unavailable — ignore
  }
};
